// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { commonEnvironment } from './common';

export const environment = {
  ...commonEnvironment,
  serveMode: false,
  production: false,
  // Uncomment to test the local hc-config files without the remote Firestore HC config
  // overriding them (see HcService.initialiseRemoteConfig).
  // use it when you want to run npm run build
  // disableRemoteHcConfig: true,
};

console.groupCollapsed('DEBUG :: Environment');
console.log(environment);
console.groupEnd();

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
